import { NgModule } from '@angular/core';
import { CommonModule } from "@angular/common";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { FryCommonModule } from "@fry/components/common";
import { MaterialModule } from "@fry/components/material";
import { UnboxedModule } from "@fry/ui";

import { EasFormModule } from '@fry/components/common/easform/easform.module';
import { ColumnsSelectorComponent } from './columns-selector/columns-selector.component';
import { FiltersSelectorComponent } from './filters-selector/filters-selector.component';
import { InteractiveTableComponent } from './interactive-table.component';
import { TableExportsComponent } from './table-exports/table-exports.component';
import { LabelFilterPipe } from './columns-selector/search.pipe';
import { RouterModule } from '@angular/router';

@NgModule({
  imports: [
    RouterModule,
    CommonModule,
    ReactiveFormsModule,
    FryCommonModule,
    MaterialModule,
    UnboxedModule,
    EasFormModule,
    FormsModule
  ],
  declarations: [
    InteractiveTableComponent,
    FiltersSelectorComponent,
    ColumnsSelectorComponent,
    TableExportsComponent,
    LabelFilterPipe
  ],
  exports: [
    InteractiveTableComponent,
  ],
  providers: [
  ]
})
export class InteractiveTableModule {}
